import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { api } from "@/lib/api/client";
import type { ChatListItem } from "../types";

const CHAT_LIST_QUERY_KEY = ["chatList"] as const;

interface UseChatHistoryReturn {
    chats: ChatListItem[];
    isLoading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

export const useChatHistory = (enabled = true): UseChatHistoryReturn => {
    const queryClient = useQueryClient();

    const { data, isLoading, error } = useQuery({
        queryKey: CHAT_LIST_QUERY_KEY,
        queryFn: async () => {
            const response = await api.listChats();
            return response.chats;
        },
        enabled,
    });

    const refetch = useCallback(async () => {
        await queryClient.invalidateQueries({ queryKey: CHAT_LIST_QUERY_KEY });
    }, [queryClient]);

    return {
        chats: data ?? [],
        isLoading,
        error: error ? (error instanceof Error ? error.message : "Failed to load chats") : null,
        refetch,
    };
};
